import { forwardRef } from 'react';
import { routeUrl } from '../lib/routing.js';
import { isPlainClick } from '../lib/linkClick.js';

/**
 * An in-app navigation control that is a real link.
 *
 * The href is the same URL `go()` pushes, so Ctrl/Cmd/Shift/middle-click opens
 * the screen in a new tab and "copy link address" works. A plain left click is
 * intercepted and handed to `onNavigate` so the app moves without a reload;
 * every other click is left to the browser (see lib/linkClick.js).
 *
 * `onClick`, if given, runs first and may preventDefault to veto navigation.
 */
export const ViewLink = forwardRef(function ViewLink(
  { view, entityId, arg = null, onNavigate, onClick, children, ...rest }, ref,
) {
  return (
    <a
      {...rest}
      ref={ref}
      href={routeUrl({ view, entityId, arg })}
      onClick={(e) => {
        onClick?.(e);
        if (!isPlainClick(e)) return;
        e.preventDefault();
        onNavigate?.();
      }}
    >
      {children}
    </a>
  );
});
